<script lang="ts" setup>
  import {
    animatedIn,
    animatedOut,
    slideInRight,
    slideOutRight,
  } from '@tundr/theme';
  import { Toast } from '@tundr/ds-components';
  import { computed } from 'vue';
  import { useToastStore } from '../../store/toast.store.ts';
  import { toastStackClass } from './ToastPresenter.css.ts';

  const store = useToastStore();

  const enterActiveClass = computed(() => `${animatedIn} ${slideInRight}`);
  const leaveActiveClass = computed(() => `${animatedOut} ${slideOutRight}`);
</script>

<template>
  <div :class="toastStackClass">
    <transition-group
      :enter-active-class="enterActiveClass"
      :leave-active-class="leaveActiveClass"
    >
      <Toast
        v-for="item in store.items.values()"
        :key="item.distinctId"
        :test-id="`toast-${item.distinctId}`"
        :distinct-id="item.distinctId"
        :variant="item.variant"
        :icon="item.icon"
        :message="item.message"
        :description="item.description"
        :detail="item.detail"
        :copyable="item.copyable"
        :closable="item.closable"
        @close="() => store.removeItem(item)"
      />
    </transition-group>
  </div>
</template>
